import { useTexture } from "@react-three/drei";
import React from "react";
import * as THREE from "three";
import Sun from "./Sun";

const Cubemap = () => {
  const [right, left, top, bottom, front, back] = useTexture([
    process.env.PUBLIC_URL + "/textures/cubemap/right.png",
    process.env.PUBLIC_URL + "/textures/cubemap/left.png",
    process.env.PUBLIC_URL + "/textures/cubemap/top.png",
    process.env.PUBLIC_URL + "/textures/cubemap/bottom.png",
    process.env.PUBLIC_URL + "/textures/cubemap/front.png",
    process.env.PUBLIC_URL + "/textures/cubemap/back.png",
  ]);

  return (
    <group>
      <Sun />
      <mesh rotation={[0.3, 3.5, 0]}>
        <boxGeometry attach="geometry" args={[300, 300, 300]} />
        <meshBasicMaterial
          attachArray="material"
          map={right}
          side={THREE.BackSide}
        />
        <meshBasicMaterial
          attachArray="material"
          map={left}
          side={THREE.BackSide}
        />
        <meshBasicMaterial
          attachArray="material"
          map={top}
          side={THREE.BackSide}
        />
        <meshBasicMaterial
          attachArray="material"
          map={bottom}
          side={THREE.BackSide}
        />
        <meshBasicMaterial
          attachArray="material"
          map={front}
          side={THREE.BackSide}
        />
        <meshBasicMaterial
          attachArray="material"
          map={back}
          side={THREE.BackSide}
        />
      </mesh>
    </group>
  );
};

export default Cubemap;
